import React, { useContext, useEffect, useRef, useState } from 'react';
import useLocation from 'hooks/useLocation';
import { useNomenclator } from './nomenclatorContext';
import {
  eleccion,
  abbrCodigoEleccionAEleccion,
  nombreEleccion,
} from 'constantes';
import getUrlResultados from '../utils/getUrlResultados';
import useQuery from '../hooks/useQuery';
import { withRouter } from 'react-router-dom';

const ViewContext = React.createContext();
const MesaContext = React.createContext();

const ViewProvider = ({ children, history }) => {
  const sideBarPortalRef = useRef(null);
  const nomenclator = useNomenclator();
  const query = useQuery();
  const location = useLocation();
  const [mesa, setMesa] = React.useState(null);

  const [state, setState] = useState({
    view: '',
    scope: {},
    elections: [],
    links: [],
    esHistorico: false,
    modalHistoricos: {
      open: false,
      url: null,
    },
  });

  useEffect(() => {
    if (!nomenclator) return;
    const isEstadisticas = state.view === 'estadisticas';
    const isIndex = state.view === 'index';
    const regex = /\/(\d+)\/(.*)/;
    const match = location.pathname.match(regex);
    const rutaAdicional =
      match && match[state.esHistorico ? 4 : 2]
        ? match[state.esHistorico ? 4 : 2]
        : '';
    const ambitoI =
      match && match[state.esHistorico ? 3 : 1]
        ? match[state.esHistorico ? 3 : 1]
        : '0';
    let elec; // index

    if (!isIndex) {
      if (!isEstadisticas) {
        elec =
          eleccion[location.pathname.split('/')[state.esHistorico ? 3 : 1]];
      } else {
        const pathArray = location.pathname.replace('/', '').split('/');
        elec = eleccion[pathArray[state.esHistorico ? 3 : 1]];
      }
    }

    elec = elec ? elec : 10;
    const scope = nomenclator.ambitos[elec][ambitoI];
    const elections = scope.r.slice(0, 5).reduce((arr, e, i) => {
      if (e >= 0) {
        const pair = {
          eleccion: abbrCodigoEleccionAEleccion[nomenclator.ordAmbitos[i]],
          ambito: nomenclator.ambitos[nomenclator.ordAmbitos[i]][e],
        };
        arr.push({
          ...pair,
          url: isEstadisticas
            ? `/estadisticas/${nombreEleccion[nomenclator.ordAmbitos[i]]}`
            : getUrlResultados(pair, rutaAdicional, query.get('zonaOComuna')),
        });
      }
      return arr;
    }, []);

    setState(s => ({
      ...s,
      scope,
      elec,
      elections,
      links: elections.map(e => e.url),
    }));
  }, [location.pathname, nomenclator, query, state.esHistorico, state.view]);

  useEffect(() => {
    const zonaOComuna = query.get('zonaOComuna');
    if (zonaOComuna) {
      window.zonaOComuna = Number(zonaOComuna);
      // history.replace(location.pathname);
    } else window.zonaOComuna = null;
  }, [history, location.pathname, query]);

  return (
    <ViewContext.Provider value={{ sideBarPortalRef, state, setState }}>
      <MesaContext.Provider value={{ mesa, setMesa }}>
        {children}
      </MesaContext.Provider>
    </ViewContext.Provider>
  );
};

export default withRouter(ViewProvider);

export const useViewContext = () => useContext(ViewContext).state;
export const useSideBarPortalRef = () =>
  useContext(ViewContext).sideBarPortalRef;
export const useSetViewContext = () => useContext(ViewContext).setState;
export function useMesa() {
  const context = useContext(MesaContext);
  return context;
}
